interface EmptyStateProps {
  message: string;
  icon?: string;
}

export default function EmptyState({
  message,
  icon = "ri-inbox-line",
}: EmptyStateProps) {
  return (
    <div className="flex w-full flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-2xl text-foreground-400">
        <i className={icon}></i>
      </span>
      <p className="mt-4 text-sm text-foreground-500">{message}</p>
    </div>
  );
}